import React from "react";
import { X, CalendarClock } from "lucide-react";
import { MillieAvatar } from "./MascotBubble";
import { eatTiming } from "../lib/eatTiming";

export default function BusyNightSheet({ open, onClose, day, dateLabel, events }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-sorted-ink/40 backdrop-blur-sm flex items-end justify-center" onClick={onClose} data-testid="busy-night-sheet">
      <div className="w-full max-w-md bg-[#FFF6F1] rounded-t-[2rem] p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3">
          <MillieAvatar size={44} float={false} mood="point" />
          <div className="flex-1">
            <p className="font-hand text-2xl text-sorted-ink leading-none">{day} evening</p>
            <p className="text-sm font-semibold text-sorted-slate mt-1">{dateLabel} · {events.length ? "here's what's on" : "marked busy by you"}</p>
          </div>
          <button onClick={onClose} aria-label="Close" data-testid="busy-night-sheet-close" className="w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-soft"><X size={18} strokeWidth={2.5} /></button>
        </div>
        <ul className="mt-5 space-y-2" data-testid="busy-night-events">
          {events.map((e, i) => (
            <li key={i} className="bg-white rounded-2xl px-4 py-3 flex items-center gap-3 shadow-soft" data-testid={`busy-night-event-${i}`}>
              <CalendarClock size={18} strokeWidth={2.5} className="text-warning shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="font-bold text-sorted-ink truncate">{e.title}</p>
                <p className="text-xs font-semibold text-sorted-slate">{e.start} – {e.end}{e.owner_name ? ` · ${e.owner_name}'s calendar` : ""}</p>
                {eatTiming(e) && <p className="text-xs font-bold text-sorted-ink mt-0.5" data-testid={`busy-night-timing-${i}`}>{eatTiming(e).label} · {eatTiming(e).sub}</p>}
              </div>
            </li>
          ))}
          {!events.length && <li className="text-sm font-semibold text-sorted-slate bg-white rounded-2xl px-4 py-3">No calendar events — you set this night as busy in your household settings.</li>}
        </ul>
        <p className="mt-4 text-xs font-semibold text-sorted-slate">Millie keeps dinner under 20 minutes on busy nights.</p>
      </div>
    </div>
  );
}
